import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Minus, Plus, ArrowLeft, Flame } from "lucide-react";
import api from "../lib/api";
import { useCart } from "../context/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [loading, setLoading] = useState(true);
  const { addItem } = useCart();

  useEffect(() => {
    api.get(`/products/${id}`)
      .then(({ data }) => { setProduct(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="max-w-7xl mx-auto py-20 text-center text-cream">LOADING...</div>;
  if (!product) return (
    <div className="max-w-7xl mx-auto py-20 text-center">
      <div className="font-display text-3xl text-cream">PRODUCT NOT FOUND</div>
      <Link to="/shop" className="text-brand font-display mt-4 inline-block">← BACK TO SHOP</Link>
    </div>
  );

  return (
    <div data-testid="product-detail-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <Link to="/shop" className="inline-flex items-center gap-2 text-[#A19D94] hover:text-brand transition mb-8">
        <ArrowLeft size={16} /> <span className="font-display tracking-widest">BACK TO SHOP</span>
      </Link>

      <div className="grid lg:grid-cols-2 gap-10">
        <div className="relative aspect-square overflow-hidden bg-ink-800 border border-ink-600">
          <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" />
          <div className="absolute top-4 left-4 font-display text-xs tracking-[0.3em] text-brand bg-ink-900/80 px-3 py-1.5 border border-brand/40">
            {product.category.toUpperCase()}
          </div>
        </div>

        <div className="flex flex-col">
          <h1 className="font-display text-5xl sm:text-6xl text-cream leading-none">{product.name.toUpperCase()}</h1>
          <div className="flex items-center gap-3 mt-4 text-sm tracking-widest text-[#A19D94]">
            <Flame size={14} className="text-brand" /> SMOKED & READY • {product.unit.toUpperCase()}
          </div>

          <div className="font-display text-6xl text-brand mt-8 leading-none">${product.price.toFixed(2)}</div>
          <div className="text-xs text-[#A19D94] mt-2 tracking-widest">{product.unit}</div>

          <p className="text-[#C8C4BB] leading-relaxed mt-8 text-lg">{product.description}</p>

          <div className="mt-12 flex flex-wrap gap-4 items-center">
            <div className="flex items-center border-2 border-ink-600">
              <button
                data-testid="pd-decrement"
                onClick={() => setQty((q) => Math.max(1, q - 1))}
                className="w-12 h-14 flex items-center justify-center hover:bg-ink-700 text-cream"
              ><Minus size={18} /></button>
              <span className="w-14 text-center font-display text-2xl text-cream" data-testid="pd-qty">{qty}</span>
              <button
                data-testid="pd-increment"
                onClick={() => setQty((q) => q + 1)}
                className="w-12 h-14 flex items-center justify-center hover:bg-ink-700 text-cream"
              ><Plus size={18} /></button>
            </div>
            <button
              data-testid="pd-add-to-cart"
              onClick={() => { addItem(product, qty); }}
              className="flex-1 sm:flex-initial px-10 h-14 bg-brand hover:bg-brand-hover text-ink-900 font-display text-2xl tracking-widest transition-all teal-glow-hover"
            >
              ADD TO CART
            </button>
          </div>

          <div className="mt-10 pt-8 border-t border-ink-600 grid grid-cols-2 gap-6 text-sm">
            <div>
              <div className="font-display text-cream text-lg tracking-widest">PICKUP</div>
              <div className="text-[#A19D94] mt-1">Gosford Showgrounds, NSW</div>
            </div>
            <div>
              <div className="font-display text-cream text-lg tracking-widest">READY</div>
              <div className="text-[#A19D94] mt-1">Choose your slot at checkout</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
